import * as React from 'react';

import ArrowSort16 from './ArrowSort16';

export const arrowSort16 = () => <ArrowSort16 />;

export default {
    title: 'Icon/Fill/ArrowSort16',
    component: ArrowSort16,
    parameters: {
        notes: "`import ArrowSort16 from 'box-ui-elements/es/icon/fill/ArrowSort16';`",
    },
};
